import React from "react"
import { FormattedMessage } from "react-intl"
import DataTable from "react-data-table-component"  // DOC https://react-data-table-component.netlify.app/?path=/docs/getting-started-intro--docs
import Button from "react-bootstrap/Button"
import Badge from 'react-bootstrap/Badge'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Trash, Gear, Copy } from "react-bootstrap-icons"

const TableManagement = ({ icon, title, columns, data, paginationPerPage, paginationTotalRows, onChangePage, onChangeRowsPerPage, onSort, onActionClick }) => {

    const columnsWithButtons = [
        ...columns,
        {
            id: 'buttons',
            name: <FormattedMessage id="textActions" defaultMessage="Actions" />,
            cell: (row) => {
                return (
                    <>
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id={`tooltip-edit`}><FormattedMessage id="textEdit" defaultMessage="Edit" /></Tooltip>}>
                            <Button
                                onClick={() => onActionClick({ data: row, type: 'edit' })}
                                variant="primary"
                                size="sm">
                                <Gear />
                            </Button>
                        </OverlayTrigger>&nbsp;

                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id={`tooltip-delete`}><FormattedMessage id="textDelete" defaultMessage="Delete" /></Tooltip>}>
                            <Button
                                onClick={() => onActionClick({ data: row, type: 'delete' })}
                                variant="danger"
                                size="sm">
                                <Trash />
                            </Button>
                        </OverlayTrigger>&nbsp;

                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id={`tooltip-delete`}><FormattedMessage id="textDuplicate" defaultMessage="Duplicate" /></Tooltip>}>
                            <Button
                                onClick={() => onActionClick({ data: row, type: 'duplicate' })}
                                variant="info"
                                size="sm">
                                <Copy />
                            </Button>
                        </OverlayTrigger>
                    </>
                )
            },
            ignoreRowClick: true,
        }
    ]

    return (
        <DataTable
            title={<><Badge bg="warning" text="dark">{icon ? icon : ''} {paginationTotalRows}</Badge> {title}</>}
            columns={columnsWithButtons}
            data={data}
            noDataComponent={<FormattedMessage id="textNoRecords" defaultMessage="There are no records to display" />}
            pagination
            paginationServer
            paginationPerPage={paginationPerPage}
            paginationTotalRows={paginationTotalRows}
            paginationComponentOptions={{
                rowsPerPageText: <FormattedMessage id="textRowsPerPage" defaultMessage="Rows per page" />
            }}
            onChangePage={onChangePage}
            onChangeRowsPerPage={onChangeRowsPerPage}
            onSort={onSort}
            sortServer
            highlightOnHover
            striped
        />
    )
}

export default TableManagement